import { StackScreenProps } from "@react-navigation/stack";
import { ManageSmartPayRootParamList } from "../../../../types";
import {
  Card,
  FlatActionList,
  Page,
  Stack,
} from "@towersystems/roam-common-native";
import React from "react";
import { ScreenContext } from "./context";

export interface ManageSmartPayScreenProps
  extends StackScreenProps<
    ManageSmartPayRootParamList,
    "ManageSmartPayScreen"
  > {}

export const ManageSmartPayScreen = ({
  navigation,
}: ManageSmartPayScreenProps) => {
  const context = React.useContext(ScreenContext);

  if (!context) {
    return null; // or a loading indicator
  }

  const title = `Manage SmartPay - ${context.paymentMethod.name}`;
  const secondaryTitle = "Manage your SmartPay payment method settings";

  return (
    <Page title={title} secondaryTitle={secondaryTitle}>
      <Stack vertical>
        <Card>
          <FlatActionList
            items={[
              {
                key: "pairing",
                title: "Pair SmartPay Device",
                subTitle:
                  "Pair a new SmartPay terminal with this payment method. Roam has no control over removing or changing the pairing code.",
                onPress: () => {
                  navigation.navigate("SmartPayPairingScreen");
                },
              },
            ]}
          />
        </Card>
      </Stack>
    </Page>
  );
};
